import React, { useEffect, useState, useRef } from 'react';
import { Popup } from 'devextreme-react/popup';

import { Button } from 'devextreme-react';


const PopupTopBestClients = ({}) => {

    const onClick = () => {
        window.open('/app/top-best-client', '_blank');   // Handle button click
    }

    return (
        <div>
            <Button
                text=""
                icon="fullscreen"
                onClick={onClick}
            />
        </div>
    );
}

export default PopupTopBestClients;
